import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-29" data-mp="10f60k2vqn0so">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-gold/30 shadow-lg relative overflow-hidden" data-id="element-30" data-mp="vlurdv3ge7xl">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-gold/10 rounded-br-full -z-10" data-id="element-31" data-mp="qmqil5kfyc7s"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-violet/10 rounded-tl-full -z-10" data-id="element-32" data-mp="mn9as5hjl2zg"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-violetDark leading-tight" data-id="element-33" data-mp="hlac38wqyu8u">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text/80 mb-10 max-w-2xl mx-auto" data-id="element-34" data-mp="7ppbnf7bu217">
          <p data-id="element-35" data-mp="27089skfftv68">
            Una que cierra esta página y la próxima sesión sigue sin genograma
            claro, sin protocolo de intervención, sin registro de seguimiento y
            sin las palabras exactas que el campo necesita escuchar.
          </p>
          <p className="font-medium text-brand-violet" data-id="element-36" data-mp="3a1casr4iy4xz">
            Y otra que decide que hoy es el día en que su práctica cambia.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-burgundy" data-id="element-37" data-mp="2v5wai4dcpct5">
            La pregunta no es si podés pagarlo.
            <br data-id="element-38" data-mp="30596pfq43w8e" />
            La pregunta es cuántas sesiones más vas a improvisar.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-display font-bold mb-8 text-brand-violetDark" data-id="element-39" data-mp="3ss3o23rmufhn">
          ¿CON CUÁL EMPEZÁS?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-10" data-id="element-40" data-mp="3e25ypkhyvjqv">
          {/* Plan 1 */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-gold/30 bg-white/85 text-center flex flex-col" data-id="element-41" data-mp="3j0zc7cx97ar1">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-violetDark mb-1" data-id="element-42" data-mp="al5w2z6u41ai">
              📘 VADEMÉCUM DEL CONSTELADOR FAMILIAR™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-violetDark mb-3" data-id="element-43" data-mp="p84j8hyns9jf">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-44" data-mp="kavzicxv3xg2">
              Libro Principal + 4 Bonos · ~230 páginas. Aplicá el sistema
              completo desde hoy.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/46818045165757:1" variant="gold" data-id="element-45" data-mp="b8wfdbrjwd8w">
              📘 → LO QUIERO $19.990
            </CTAButton>
          </div>

          {/* Plan 2 — featured */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-goldDark bg-white text-center flex flex-col relative animate-glow-pulse shadow-[0_0_34px_rgba(201,169,97,0.45)] md:scale-[1.04] z-[1] mt-3 md:mt-0" data-id="element-46" data-mp="3snjpr97tw0zt">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 gold-gradient-bg text-brand-ink text-[10px] md:text-xs font-extrabold tracking-wider uppercase px-3.5 py-1 rounded-full shadow-md whitespace-nowrap inline-flex items-center gap-1" data-id="element-47" data-mp="3eplhmlk3p0sr">
              ⭐ Más elegido · Mejor opción
            </div>
            <p className="mt-3 mb-1 text-[11px] md:text-xs font-bold text-brand-goldDark tracking-wide" data-id="element-48" data-mp="247bkimnv04yy">
              ✨ La opción más completa — el sistema entero + la Maestría
            </p>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-violet mb-1" data-id="element-49" data-mp="1bie3emvdwe7s">
              🏆 VADEMÉCUM + MAESTRÍA EN CONSULTA SISTÉMICA™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-violet mb-3" data-id="element-50" data-mp="1kij8urh0p2jb">
              $27.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-51" data-mp="1p99c9z5vuvbd">
              Libro Principal + 4 Bonos + Maestría · ~280 páginas. Dominá la
              clínica sistémica Y la excelencia en el campo.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5 cta-shimmer relative overflow-hidden font-bold" href="https://www.lumenakasha.com/cart/46818045296829:1" variant="purple" data-id="element-52" data-mp="wr5g4keyf4xt">
              🏆 → SÍ, LO QUIERO TODO — $27.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-53" data-mp="immx1dg3cmcm">
          <div className="flex items-center" data-id="element-54" data-mp="wd9vd4hxwa86">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-55" data-mp="rfi6ykgi768q" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-56" data-mp="16cha9w4bocxe">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-57" data-mp="16c8vtzsjwzk3" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-58" data-mp="11efqf8z2o9kv">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-59" data-mp="383lz6keveze1" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-60" data-mp="335su5upb0bfc">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-61" data-mp="336vn0866snxw" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="text-sm text-brand-text/70 bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-gold/20 space-y-3 text-left md:text-center" data-id="element-62" data-mp="1nmct11tyc5wp">
          <p data-id="element-63" data-mp="18vcj0sdk43yg">
            <strong className="text-brand-violetDark" data-id="element-64" data-mp="1dw0aff5p6mt7">P.D.:</strong> Si tenés
            dudas, escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-goldDark hover:underline font-medium" data-id="element-65" data-mp="zvz77t1yn3ak">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-goldDark hover:underline font-medium" data-id="element-66" data-mp="q05n9olww7ir">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="italic text-brand-violet" data-id="element-67" data-mp="2pbynrv7wrv08">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu
            sistema clínico es ahora.
          </p>
        </div>
      </div>
    </Section>;
};